// Max number of item in the chart's legend
export const MAX_LEGEND_LENGTH = 2;
// Max number of item in the chart's tooltip
export const MAX_TOOLTIP_LENGTH = 2;
